import React, { Component } from "react";
import Layout from "../Layout";
import * as ApiHelper from "../../ApiHelper";
import { withRouter, Link } from "react-router-dom";
import * as constants from "../../constants";

class Fiscalizacao extends Component {
  print(event) {
    event.preventDefault();
    ApiHelper.getRelatorioEstatico((relatorio) => {
      if (relatorio) {
        var url = URL.createObjectURL(relatorio);
        var tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute(
          "download",
          "Relatório de Acompanhamento do Fiscal de Contrato.pdf"
        );
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      } else {
        console.log("Error");
      }
    });
  }

  render() {
    var fiscalizacaoTable = [
      {
        label: "Atas de reunião",
        link: "/atareuniao",
        icon: "assignment",
        type: "as",
      },
      {
        label: "Notificação",
        link: "/solicitacaoesclarecimento",
        icon: "assignment_late",
        type: "as",
      },
      {
        label: "Diário de ocorrências",
        link: "/diarioocorrencias",
        icon: "description",
        type: "as",
      },
      {
        label: "Prorrogação contratual",
        link: "/prorrogacaocontratual",
        icon: "description",
        type: "as",
      },
      {
        label: "Termo circunstanciado",
        link: "/termocircunstanciado",
        icon: "description",
        type: "as",
      },
    ];
    return (
      <Layout tabActive="Fiscalização">
        {fiscalizacaoTable.map((item, key) => {
          return (
            <div key={key} className="col-sm-offset-1 row">
              <Link to={item.link}>
                <div
                  className={
                    "col-sm-10 alert alert-" + item.type + " alert-with-icon"
                  }
                  data-notify="container"
                >
                  <i data-notify="icon" className="material-icons">
                    {item.icon}
                  </i>
                  <span data-notify="message">{item.label}</span>
                </div>
              </Link>
            </div>
          );
        })}
        {constants.getCidade() !== "Granja" ? "" : (
          <div className="col-sm-offset-1 row">
            <Link to="#" onClick={this.print} style={{ alignSelf: "center" }}>
              <div
                className={"col-sm-10 alert alert-" + "as" + " alert-with-icon"}
                data-notify="container"
              >
                <i data-notify="icon" className="material-icons">
                  description
                </i>
                <span data-notify="message">Relatório de Acompanhamento Fiscal</span>
              </div>
            </Link>
          </div>
        )}
      </Layout>
    );
  }
}
export default withRouter(Fiscalizacao);



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/Fiscalizacao.js